/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Bank_AccountInputs */

const vi_grower_bank_account = /** @type {(inputs: Grower_Bank_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chủ tài khoản`)
};

/**

* @param {Grower_Bank_AccountInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_bank_account = /** @type {((inputs?: Grower_Bank_AccountInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Bank_AccountInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_bank_account(inputs)
});